import BigButton from './BigButton';

export default BigButton;
